import React from 'react';
import CourseCard from './CoursesPageCard';

const CoursesGrid = ({ courses }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
    {courses.map((course) => (
      <CourseCard key={course.id} course={course} />
    ))}
  </div>
);

export default CoursesGrid;